import { OpenSpace } from '../entities/openSpace';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ReportTrackParticipationVsVotes } from '../entities/ReportTrackParticipationVsVotes';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})

export class ReportService {

    private baseUrl = environment.apiUrl + '/api/report/';
    basic: string | string[];

    constructor(private http: HttpClient) { }

  getTracksParticipantVsVoters(openId: number): Observable<any> {
    return this.http.get<ReportTrackParticipationVsVotes[]>(`${this.baseUrl}openspace/${ openId }/trackParticipationVsVoters`);
  }

  proposalByCateory(openId: number): Observable<any> {
    return this.http.get<ReportTrackParticipationVsVotes[]>(`${this.baseUrl}openspace/${ openId }/proposalByCateory`);
  }

  getSurvey(openId: number): Observable<any> {
    return this.http.get<ReportTrackParticipationVsVotes[]>(`${this.baseUrl}openspace/${ openId }/survey`);
  }

  getTotalVoters(openId: number): Observable<any> {
    return this.http.get<ReportTrackParticipationVsVotes[]>(`${this.baseUrl}openspace/${ openId }/voters`);
  }
}
